import gsap from "gsap";
import "../styles/preloader.css";
import { useRef, useEffect } from "react";

const Preloader = ({ onAnimationComplete }) => {
  const placeholderRef = useRef(null);
  const subheaderRef = useRef(null);
  const containerRef = useRef(null);

   const animateScale = (element, scaleValue) => {
    if (!element) return;
    gsap.fromTo(
      element,
      { scale: 1 },
      { scale: scaleValue, duration: 2, ease: "power1.out" }
    );
  };

   const wrapLetters = (text) => {
    const placeholder = placeholderRef.current;
    if (!placeholder) return;
    placeholder.innerHTML = "";
    [...text].forEach((letter) => {
      const span = document.createElement("span");
      span.style.filter = "blur(8px)";
      span.textContent = letter;
      placeholder.appendChild(span);
    });
  };

   const animateBlurEffect = () => {
    const placeholder = placeholderRef.current;
    if (!placeholder) return;
    const letters = placeholder.children;
    let index = 0;

    function clearNextLetter() {
      if (index < letters.length) {
        gsap.to(letters[index], { filter: "blur(0px)", duration: 0.5 });
        index++;
        setTimeout(clearNextLetter, 100);
      }
    }
    clearNextLetter();
  };

   const shuffleLetters = (finalText, callback) => {
    const placeholder = placeholderRef.current;
    if (!placeholder) return;

    wrapLetters(finalText);
    const letters = placeholder.children;

    let completed = 0;
    for (let i = 0; i < finalText.length; i++) {
      let iterations = 0;
      const targetChar = finalText[i];

      const interval = setInterval(() => {
        if (iterations < 5 && targetChar !== " ") {
          // randomize a few times
          letters[i].textContent =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(Math.random() * 26)];
          iterations++;
        } else {
          // lock to final char
          letters[i].textContent = targetChar;
          clearInterval(interval);
          completed++;

          // ✅ When all letters are done
          if (completed === finalText.length) {
            animateBlurEffect();
            if (callback) callback();
          }
        }
      }, 50);
    }
  };

useEffect(() => {
  const defaultText = "Roarz Kreatives";
  const defaultSubheaderText = "Bringing Your Dreams to Reality!";

  if (subheaderRef.current) {
    subheaderRef.current.textContent = defaultSubheaderText;
  }

  animateScale(placeholderRef.current, 1.25);

  shuffleLetters(defaultText, () => {
    // fade + scale before unmounting
    gsap.to(containerRef.current, {
      
      duration: 2,
      ease: "power2.inOut",
      onComplete: () => {
        if (onAnimationComplete) onAnimationComplete();
      }
    });
  });
}, [onAnimationComplete]);


  return (
    <div ref={containerRef} className="loader-container">
      <div className="loader-header">
        <div ref={placeholderRef} className="placeholder">
          Roarz Kreatives
        </div>
     
      </div>
    </div>
  );
};

export default Preloader;
